export default {
	path: 'achvmPlans',
	name: 'AchvmPlanForm.vue',
	component() {
		return import('@/components/achvmPlan/AchvmPlanForm.vue')
	},
	children: [
		{
			path: '',
			name: 'AchvmPlanList',
			component() {
				return import('@/components/achvmPlan/AchvmPlanList.vue')
			},
		},
		{
			path: ':seqnr',
			name: 'AchvmPlanDetail',
			component() {
				return import('@/components/achvmPlan/AchvmPlanDetail.vue')
			},
		},
	],
}